export const getShoppingReasonCopy = () => ({
  question: "Which best describes your reason for shopping?",
  options: {
    FAMILY_PLAN: "I need a good plan for myself and my family",
    BEST_BENEFITS: "I need to offer benefits to attract and retain talent",
    BASIC_COVERAGE: "I want to help my employees get basic coverage",
    CHEAPER_PLAN: "I have a plan, but am hoping to reduce the cost",
    NONE_OF_THE_ABOVE: "None of the above",
  },
});

export const getDoctorImportanceCopy = () => ({
  question: "How important is it to maintain your existing doctors?",
  options: {
    NOT_IMPORTANT: "I will find doctors that fit within whatever plan is best",
    SPECIFIC_DOCTOR: "I have specific doctors that must be covered",
    LARGE_NETWORK: "I don't have specific doctors, but I want a large network",
    NOT_SURE: "I'm not sure",
  },
});

export const getDeductibleImportanceCopy = () => ({
  NOT_IMPORTANT: "I'm ok with a high deductible to reduce the monthly cost",
  LOW_DEDUCTIBLE: "I'm willing to pay more to have a lower deductible",
  LOW_PREMIUM: "I'd like a plan with a moderate deductible, but lower monthly premiums",
  NOT_SURE: "I'm not sure",
});

export const getEmployeeDemographicCopy = () => ({
  numYoung: "Young and healthy",
  numOld: "Older or have chronic conditions",
  numChildren: "Have children or are pregnant",
  numNotSure: "Not sure",
});

export const getOtherCopy = () => ({
  isHsaImportant: "I want to be able to utilize a health savings account (HSA)",
  isMultiplePlansImportant: "I want to give my employees multiple options",
  isOutOfStateImportant: "I have employees who live outside my home state",
  isNationalNetworkImportant: "I travel frequently and need a national network of doctors",
});

const analyzeMetalTierFit = (metalTier, surveyResults) => {
  let tierIsRight;
  let tierExplanation;

  if (metalTier === "bronze") {
    if (surveyResults.deductibleImportance === "LOW_DEDUCTIBLE") {
      tierIsRight = false;
      tierExplanation =
        "you indicated that you prefer plans with \
      low deductibles and the plan you have chosen has a high deductible compared to other plans to choose from";
    } else {
      tierIsRight = true;
      tierExplanation = "This plan has lower monthly costs due to a higher deductible";
    }
  } else if (metalTier === "gold") {
    if (surveyResults.shoppingReason === "BASIC_COVERAGE" || surveyResults.deductibleImportance === "NOT_IMPORTANT") {
      tierIsRight = false;
      tierExplanation = "this plan has comprehensive coverage but may be more expensive than what you need";
    } else {
      tierIsRight = true;
      tierExplanation = "This plan provides comprehensive coverage and low out of pocket costs";
    }
  }

  return { tierIsRight, tierExplanation };
};

const analyzePlanTypeFit = (planType, surveyResults) => {
  let typeIsRight;
  let typeExplanation;

  if (planType === "HMO") {
    if (surveyResults.doctorImportance === "LARGE_NETWORK") {
      typeIsRight = false;
      typeExplanation =
        "this plan's network is relatively small compared to \
        other plans available and you indicated that a large doctor network is important to you";
    } else if (surveyResults.isOutOfStateImportant === true) {
      typeIsRight = false;
      typeExplanation =
        "this plan's network only covers in-state employees. \
        The employees who you indicated are out-of-state would not be in-network for this plan";
    } else if (surveyResults.isNationalNetworkImportant === true) {
      typeIsRight = false;
      typeExplanation =
        "this plan's network only covers you while \
        you are in-state and you indicated that you travel out of state often";
    } else {
      typeIsRight = true;
      typeExplanation = "reduces monthly costs by having a narrower doctor network";
    }
  } else if (surveyResults.doctorImportance === "NOT_IMPORTANT") {
    typeIsRight = false;
    typeExplanation =
      "you indicated that you prefer a smaller doctor network in \
        order to reduce costs and this plan has a large doctor network, which makes it more expensive compared to other plans";
  } else {
    typeIsRight = true;
    typeExplanation = "is right because it provides a wide, nationwide doctor network";
  }

  return { typeIsRight, typeExplanation };
};

export const analyzePlanFit = (plan, surveyResults) => {
  const metalTier = plan.metal_tier;
  const planType = plan.plan_type;
  let planIsRight;
  let explanation;

  const { tierIsRight, tierExplanation } = analyzeMetalTierFit(metalTier, surveyResults);

  const { typeIsRight, typeExplanation } = analyzePlanTypeFit(planType, surveyResults);

  // if tier and type are both a good fit or both a bad fit then concatenate the explanations
  // if one is a good fit and one is a bad fit, return the explanation for the 'bad fit' result
  if (tierIsRight === typeIsRight) {
    explanation = tierIsRight
      ? `${tierExplanation}, and it ${typeExplanation}`
      : `Why we recommend a different plan: ${_.capitalize(tierExplanation)}. \
        We also recommend a different plan because ${typeExplanation}.`;
    planIsRight = tierIsRight;
  } else if (tierIsRight === false) {
    explanation = `Why we recommend a different plan: ${_.capitalize(tierExplanation)}.`;
    planIsRight = tierIsRight;
  } else {
    explanation = `${typeIsRight ? "This plan" : "Why we recommend a different plan:"} ${_.capitalize(typeExplanation)}.`;
    planIsRight = typeIsRight;
  }

  return { planIsRight, explanation, typeIsRight };
};
